var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import stylesFlagIcon from 'flag-icon-css/css/flag-icon.css';
import stylesMain from './styles/main.css';


var finalStyles = _extends({}, stylesFlagIcon, stylesMain);

export default finalStyles;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/module/styles.js
// module id = 968
// module chunks = 2